module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zk-spinner"
  }, [_c('svg', {
    staticClass: "zk-spinner-inner",
    style: ({
      width: _vm.radius / 2 + 'px',
      height: _vm.radius / 2 + 'px'
    }),
    attrs: {
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "20",
      "fill": "none",
      "stroke": _vm.strokeColor,
      "stroke-width": _vm.strokeWidth
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-02eb29fd"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/spinner/src/spinner.vue
// module id = 231
// module chunks = 0